import {
  Stack,
  styled,
  Text,
  MenuItem,
  SwitchLabel,
  Box,
} from '@ltvco/refresh-lib/theme';

export const StyledSwitchLabel = styled(SwitchLabel)(({ theme }) => ({
  padding: 0,
  overflow: 'visible',
  '& .MuiSwitch-thumb': {
    width: 20,
    height: 20,
  },
  '& .Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.primary,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    '&:before': {
      content: '""',
    },
  },
  '& .MuiSwitch-track': {
    width: 60,
    height: 28,
    backgroundColor: theme.palette.text.secondary,
    '&:after': {
      content: '""',
    },
  },
}));

export const TopSection = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
  },
}));

export const TopSubtitle = styled(Text)(({ theme }) => ({
  textAlign: 'center',
  width: '75%',
  marginBottom: '24px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    textAlign: 'left',
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const BannerContainer: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(() => ({
  width: '100%',
  minHeight: '60vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledBannerIcon: React.ComponentType<
  React.ComponentProps<'img'>
> = styled('img')(() => ({
  height: '65px',
  transform: 'translateX(-10px)',
  display: 'block',
}));
